<template>
    <div class="p-10">
        <!-- <h3></h3> -->
        <div class="row">
            <div class="col-lg-2 col-12 mt-1 mb-1 ">
                <div class="title h-100">
                    <h3>Stock Opname</h3>
                </div>
            </div>
            <div class="col-lg-3 col-12 row mb-1">
                <div class="col-6">
                    <button 
                        class="btn w-100 h-100" 
                        :class="{'btn-dark-blue' : filter.type == 'surprise' , 'btn-lg-grey' : filter.type != 'surprise'}"
                        @click="filter.type = 'surprise'"
                    >
                        Surprise
                    </button>
                </div>
                <div class="col-6">
                    <button 
                        class="btn w-100 h-100" 
                        :class="{'btn-dark-blue' : filter.type == 'terjadwal' , 'btn-lg-grey' : filter.type != 'terjadwal'}"
                        @click="filter.type = 'terjadwal'"
                    >
                        Terjadwal
                    </button>
                </div>
            </div>
            <div class="col-lg-2"></div>
            <div class="col-lg-5 col-12 mb-1">
                <div class="row">
                    <div class="col-4">
                        <Multiselect 
                            class="w-100"
                            :options="filterOptions.status"
                            v-model="filter.status"
                            placeholder="All Status"
                        />
                    </div>
                    <div class="col-4">
                        <Multiselect 
                            :options="filterOptions.dealer.map(x => x.loc_code)"
                            :custom-label="opt => filterOptions.dealer.find(x => x.loc_code == opt).showName"
                            v-model="filter.dealer"
                            placeholder="All Dealer (Isi 2 Kata)"
                            :internal-search="false"
                            @search-change="searchDealer"
                        />
                    </div>
                    <div class="col-4">
                        <button class="btn w-100 h-100 btn-green" @click="requestOpname">Request Opname</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-white mt-5 p-30 rounded">
            <vue-universal-table 
                :buttons="table.buttons"
                :api_url="'/api/history-opname'"
                :filter="filter"
                :table_striped="false"
                :update="table.update"
                :fields="filter.type == 'surprise' ? table.fields : table.fieldsJadwal"
                @onLihatDetail="showDetail"
            />
        </div>
        
    </div>
</template>

<script>
    import qs from 'qs'
    import customFilter from '@/components/filter/customFilter'
    import Multiselect from 'vue-multiselect'
    // import highlightStats from './children/HighlightStats'

    // import scanAndSuspiciousItemBarChart from './children/scanAndSuspiciousItemBarChart'
    // import mostSuspiciousProductPieChart from './children/mostSuspiciousProductPieChart'
    // import scanByLocationBarChart from './children/scanByLocationBarChart.vue'

    export default {
        metaInfo : {
            title : 'Stock Opname'
        },
        components : {
            Multiselect
        },
        methods : {
            showDetail(id) {
                this.$router.push({name : 'StockOpnameDetail' , params : {id : id},  query : {from : 'StockOpname'} })
            },
            requestOpname() {
                this.$router.push({name : 'StockOpnameRequest'})
            },
            async searchDealer (query) {
                let dealerList = await this.$store.getters.getDealer()
                dealerList = dealerList.filter(x => x.showName.toLowerCase().includes(query.toLowerCase()) && query.length > 1)
                this.filterOptions.dealer = dealerList
                
            },
        },
        data () {

            return {
                filter : {
                    status : null,
                    dealer : null,
                    type : 'surprise'
                },
                // filterOptions : this.$store.getters.getFilterOptions,
                filterOptions : {
                    status : this.$store.getters.getFilterOptions.status,
                    dealer : []
                },
                sampleData : [{
                    id : 1,
                    dealer : 'CV Abadi Jaya Motor',
                    total_unit : 200,
                    pic : 'Erik',
                    jadwal_aktivitas : '19 October 2022 19:00',
                    durasi : '120 Menit',
                    status : 'Selesai'
                },{
                    id : 2,
                    dealer : 'CV Abadi Jaya Motor',
                    total_unit : 200,
                    pic : 'Erik',
                    jadwal_aktivitas : '19 October 2022 19:00',
                    durasi : '120 Menit',
                    status : 'Selesai'
                },{
                    id : 3,
                    dealer : 'CV Abadi Jaya Motor',
                    total_unit : 200,
                    pic : 'Erik',
                    jadwal_aktivitas : '19 October 2022 19:00',
                    durasi : '120 Menit',
                    status : 'Selesai'
                },{
                    id : 4,
                    dealer : 'CV Abadi Jaya Motor',
                    total_unit : 200,
                    pic : 'Erik',
                    jadwal_aktivitas : '19 October 2022 19:00',
                    durasi : '120 Menit',
                    status : 'Selesai'
                }],
                table : {
                    buttons : [{
                        title : 'LihatDetail',
                        class : 'btn color-space-blue',
                        variable : 'id'
                    }],
                    update : 0,
                    fieldsJadwal : [{
                        title : 'ID',
                        variable : 'id'
                    },{
                        title : 'Dealer',
                        variable : 'dealer'
                    } , {
                        title : 'Dealer Name',
                        variable : 'nama_dealer'
                    }, {
                        title : 'Total Unit',
                        variable : 'total_unit'
                    }, {
                        title : 'Jadwal Aktivitas (Tanggal Mulai)',
                        variable : 'tgl_aktivitas'
                    },{
                        title : 'PIC',
                        variable : 'pic'
                    }, {
                        title : 'Duration',
                        variable : 'durasi'
                    }, {
                        title : 'Status',
                        variable : 'status',
                        style_condition : {
                            'In Progress' : 'color : #C6A700',
                            'Done' : 'color : #00B14B',
                            'Open' : 'color : #E02525',
                            'Expired' : 'color:#A3A3A3',
                        }
                    }],
                    fields : [{
                        title : 'ID',
                        variable : 'id'
                    },{
                        title : 'Dealer',
                        variable : 'dealer'
                    } , {
                        title : 'Dealer Name',
                        variable : 'nama_dealer'
                    }, {
                        title : 'Total Unit',
                        variable : 'total_unit'
                    }, {
                        title : 'Jadwal Aktivitas (Target Mulai)',
                        variable : 'tgl_aktivitas'
                    },{
                        title : 'PIC',
                        variable : 'pic'
                    }, {
                        title : 'Duration',
                        variable : 'durasi'
                    }, {
                        title : 'Status',
                        variable : 'status',
                        style_condition : {
                            'In Progress' : 'color : #C6A700',
                            'Done' : 'color : #00B14B',
                            'Open' : 'color : #E02525',
                            'Expired' : 'color:#A3A3A3',
                        }
                    }]
                }
            }
        },
        watch : {
            filter : {
                deep : true,
                handler () {
                    this.table.update++;
                }
            }
        }
    }
</script>